export const onboardingTargetIds = {
  accountSetup: 'onboarding-account-setup',
  aiAgent: 'onboarding-ai-agent',
  supportOperator: 'onboarding-support-operator'
} as const;